import { useEffect, useRef } from "react";
import styles from "./ContextMenu.module.css";

export const ContextMenu = ({ x, y, options, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
      onClose();
    };

    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    // Delay attaching contextmenu listener to avoid catching the event that opened the menu
    const timeoutId = setTimeout(() => {
      document.addEventListener("contextmenu", handleContextMenu);
    }, 100);

    // Close on click outside or Escape key
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className={styles.contextMenu}
      style={{ top: `${y}px`, left: `${x}px` }}
    >
      {options.map((option, index) => (
        <div
          key={index}
          className={styles.contextMenuItem}
          onClick={() => {
            option.action();
            onClose();
          }}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};
